<!-- make a button icon switching between light and dark with mat-icon material-->
<button
    mat-icon-button
    (click)="toggleTheme()">
    <mat-icon>{{ theme === 'dark' ? 'dark_mode' : 'light_mode' }}</mat-icon>
</button>